import * as React from 'react';
import { AdministrationMessagesTranslation } from '../../constants';
import { AdministrationMessagesListState } from '../types-store';

interface NumberOfResultsProps {
  listState: AdministrationMessagesListState;
  translation: AdministrationMessagesTranslation;
}

export const NumberOfResults: React.FC<NumberOfResultsProps> = ({ listState, translation }) => {

  if (!listState || !listState.messages) {
    return null;
  }

  return <p id="messages_number_of_results">
    {listState.numberOfResults === 0
      ? translation.search_no_hits
      : `${listState.numberOfResults} ${translation.search_hits}`}
  </p>;
};
